import React from "react";

const AboutData = ({ content }) => (
  <div className="mb-6" aria-label="About the Data">
    <div className="o-container--constrained" dangerouslySetInnerHTML={{ __html: content }} />
  </div>
);

export default AboutData;
